import { FC } from 'react';
import { COLORS } from '../../main/utils/Colors';

interface Props {
  width: number;
  height: number;
  color: COLORS;
}

export const DotIcon: FC<Props> = ({ width, height, color }) => (
  <svg width={width} height={height} viewBox="0 0 640 640">
    <path d="M64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z" fill={color} />
  </svg>
);
